// api controlls
import { baseURL } from "../ApiConstant";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import apiClient from "../apiClient";
import { ProjectSpendingTypes } from "../../Controllers/Types/HeyTraderTypes/ProjectSpending/ProjectSpendingTypes";
import { ShareContactTypes } from "../../Controllers/Types/HeyTraderTypes/ShareContactTypes";
import { ShareContactType } from "../../Controllers/Types/Share/ShareContactType";

// models from types
export const getAllSpendingProjectListService = async () => {
  try {
    const response = await apiClient.get(`/api/spending-project-data`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

//create function for projects add
export const addProjectForSpending = async (
  listx: ProjectSpendingTypes[]
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list

    const list = listx.map((e) => e.project_id);

    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(`${baseURL}/api/spending-project-add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ list }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// create shop names
export const addProjctSpendingShop = async (
  shop_name: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list

    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(`${baseURL}/api/spending-shop/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ shop_name }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// get all shops details
export const getAllSpendingProjectShopListService = async () => {
  try {
    const response = await apiClient.get(`/api/spending-shop/list`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

//mpurchase add
export const addMpurchaseDetails = async (
  project_id: number,
  date: string,
  shop_id: number,
  material_type: string,
  title: string,
  amount: number,
  file: File
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    /* create form data */
    const formData = new FormData();
    formData.append("project_id", String(project_id));
    formData.append("date", date);
    formData.append("shop_id", String(shop_id));
    formData.append("material_type", material_type);
    formData.append("title", title);
    formData.append("amount", String(amount));
  
    if (file) {
      formData.append("file", file);
    }
    const response = await fetch(
      `${baseURL}/api/spending-project-mpurchase/create`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: formData ,
      }
    );
    const data = await response.json();
    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//mpurchase update
export const updateMpurchaseDetails = async (
    project_id: number,
    date: string,
    shop_id: number,
    material_type: string,
    title: string,
    amount: number,
    file: File,
    id:number
  ): Promise<CommonApiResponse> => {
    try {
      const token = localStorage.getItem("token");
      const FULL_TOKEN = `Bearer ${token}`;
  
      /* create form data */
      const formData = new FormData();
      formData.append("project_id", String(project_id));
      formData.append("date", date);
      formData.append("shop_id", String(shop_id));
      formData.append("material_type", material_type);
      formData.append("title", title);
      formData.append("amount", String(amount));
      formData.append("date", date);
      if (file) {
        formData.append("file", file);
      }
      const response = await fetch(
        `${baseURL}/api/spending-project-mpurchase/update/${id}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: FULL_TOKEN,
          },
          body:formData ,
        }
      );
  
      const data = await response.json();
  
      if (response.status === 200) {
        return { status: true, statusCode: 200 };
      } else if (response.status === 401) {
        return { status: false, statusCode: 401, massage: "Unauthorized" };
      } else if (response.status === 422) {
        return {
          status: false,
          statusCode: 422,
          errors: data["errors"],
          massage: "Body error",
        };
      } else if (response.status === 404) {
        return { status: false, statusCode: 404, massage: "Not found" };
      } else {
        return { status: false, statusCode: 500, massage: "Error" };
      }
    } catch (error) {
      throw error;
    }
  };
  
// common delete functions
export const projectSpendingDetalsDelete = async (id: number): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/spending-project/delete/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

//labour add
export const addLabourDetails = async (
    project_id: number,
    date: string,
    title: string,
    amount: number,
    file: File
  ): Promise<CommonApiResponse> => {
    try {
      const token = localStorage.getItem("token");
      const FULL_TOKEN = `Bearer ${token}`;
      /* create form data */
      const formData = new FormData();
      formData.append("project_id", String(project_id));
      formData.append("date", date);
      formData.append("title", title);
      formData.append("amount", String(amount));
    
      if (file) {
        formData.append("file", file);
      }
      const response = await fetch(
        `${baseURL}/api/spending-project-labour/create`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: FULL_TOKEN,
          },
          body: formData ,
        }
      );
      const data = await response.json();
      if (response.status === 200) {
        return { status: true, statusCode: 200 };
      } else if (response.status === 401) {
        return { status: false, statusCode: 401, massage: "Unauthorized" };
      } else if (response.status === 422) {
        return {
          status: false,
          statusCode: 422,
          errors: data["errors"],
          massage: "Body error",
        };
      } else if (response.status === 404) {
        return { status: false, statusCode: 404, massage: "Not found" };
      } else {
        return { status: false, statusCode: 500, massage: "Error" };
      }
    } catch (error) {
      throw error;
    }
  };

//labour update
export const updateLabourDetails = async (
      project_id: number,
      date: string,
      title: string,
      amount: number,
      file: File,
      id:number
    ): Promise<CommonApiResponse> => {
      try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        /* create form data */
        const formData = new FormData();
        formData.append("project_id", String(project_id));
        formData.append("date", date);
        formData.append("title", title);
        formData.append("amount", String(amount));
        formData.append("date", date);
        if (file) {
          formData.append("file", file);
        }
        const response = await fetch(
          `${baseURL}/api/spending-project-labour/update/${id}`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              Authorization: FULL_TOKEN,
            },
            body:formData ,
          }
        );
    
        const data = await response.json();
    
        if (response.status === 200) {
          return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
          return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
          return {
            status: false,
            statusCode: 422,
            errors: data["errors"],
            massage: "Body error",
          };
        } else if (response.status === 404) {
          return { status: false, statusCode: 404, massage: "Not found" };
        } else {
          return { status: false, statusCode: 500, massage: "Error" };
        }
      } catch (error) {
        throw error;
      }
};
    

//labour add
export const addOtherDetails = async (
    project_id: number,
    date: string,
    title: string,
    amount: number,
    file: File
  ): Promise<CommonApiResponse> => {
    try {
      const token = localStorage.getItem("token");
      const FULL_TOKEN = `Bearer ${token}`;
      /* create form data */
      const formData = new FormData();
      formData.append("project_id", String(project_id));
      formData.append("date", date);
      formData.append("title", title);
      formData.append("amount", String(amount));
    
      if (file) {
        formData.append("file", file);
      }
      const response = await fetch(
        `${baseURL}/api/spending-project-others/create`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: FULL_TOKEN,
          },
          body: formData ,
        }
      );
      const data = await response.json();
      if (response.status === 200) {
        return { status: true, statusCode: 200 };
      } else if (response.status === 401) {
        return { status: false, statusCode: 401, massage: "Unauthorized" };
      } else if (response.status === 422) {
        return {
          status: false,
          statusCode: 422,
          errors: data["errors"],
          massage: "Body error",
        };
      } else if (response.status === 404) {
        return { status: false, statusCode: 404, massage: "Not found" };
      } else {
        return { status: false, statusCode: 500, massage: "Error" };
      }
    } catch (error) {
      throw error;
    }
  };

//labour update
export const updateOtherDetails = async (
      project_id: number,
      date: string,
      title: string,
      amount: number,
      file: File,
      id:number
    ): Promise<CommonApiResponse> => {
      try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        /* create form data */
        const formData = new FormData();
        formData.append("project_id", String(project_id));
        formData.append("date", date);
        formData.append("title", title);
        formData.append("amount", String(amount));
        formData.append("date", date);
        if (file) {
          formData.append("file", file);
        }
        const response = await fetch(
          `${baseURL}/api/spending-project-others/update/${id}`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              Authorization: FULL_TOKEN,
            },
            body:formData ,
          }
        );
    
        const data = await response.json();
    
        if (response.status === 200) {
          return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
          return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
          return {
            status: false,
            statusCode: 422,
            errors: data["errors"],
            massage: "Body error",
          };
        } else if (response.status === 404) {
          return { status: false, statusCode: 404, massage: "Not found" };
        } else {
          return { status: false, statusCode: 500, massage: "Error" };
        }
      } catch (error) {
        throw error;
      }
};
    

//mpurchase add
export const addQuotationsDetails = async (
    project_id: number,
    date: string,
    shop_id: number,
   
    title: string,
    amount: number,
    file: File
  ): Promise<CommonApiResponse> => {
    try {
      const token = localStorage.getItem("token");
      const FULL_TOKEN = `Bearer ${token}`;
      /* create form data */
      const formData = new FormData();
      formData.append("project_id", String(project_id));
      formData.append("date", date);
      formData.append("shop_id", String(shop_id));
      formData.append("title", title);
      formData.append("amount", String(amount));
    
      if (file) {
        formData.append("file", file);
      }
      const response = await fetch(
        `${baseURL}/api/spending-project-quotation/create`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: FULL_TOKEN,
          },
          body: formData ,
        }
      );
      const data = await response.json();
      if (response.status === 200) {
        return { status: true, statusCode: 200 };
      } else if (response.status === 401) {
        return { status: false, statusCode: 401, massage: "Unauthorized" };
      } else if (response.status === 422) {
        return {
          status: false,
          statusCode: 422,
          errors: data["errors"],
          massage: "Body error",
        };
      } else if (response.status === 404) {
        return { status: false, statusCode: 404, massage: "Not found" };
      } else {
        return { status: false, statusCode: 500, massage: "Error" };
      }
    } catch (error) {
      throw error;
    }
  };
  
  //mpurchase update
  export const updateQuotationsDetails = async (
      project_id: number,
      date: string,
      shop_id: number,
    
      title: string,
      amount: number,
      file: File,
      id:number
    ): Promise<CommonApiResponse> => {
      try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
    
        /* create form data */
        const formData = new FormData();
        formData.append("project_id", String(project_id));
        formData.append("date", date);
        formData.append("shop_id", String(shop_id));
     
        formData.append("title", title);
        formData.append("amount", String(amount));
        formData.append("date", date);
        if (file) {
          formData.append("file", file);
        }
        const response = await fetch(
          `${baseURL}/api/spending-project-quotation/update/${id}`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              Authorization: FULL_TOKEN,
            },
            body:formData ,
          }
        );
    
        const data = await response.json();
    
        if (response.status === 200) {
          return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
          return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
          return {
            status: false,
            statusCode: 422,
            errors: data["errors"],
            massage: "Body error",
          };
        } else if (response.status === 404) {
          return { status: false, statusCode: 404, massage: "Not found" };
        } else {
          return { status: false, statusCode: 500, massage: "Error" };
        }
      } catch (error) {
        throw error;
      }
    };
    
// share spending projects
export const shareProjectSpending = async (
  share: ShareContactType[], project_id:number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/spending-project-share`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({project_id, share }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};
